const ProjectsData = [
    {
        title : "Tic Tac Toe",
        text : "It is a game in which two players seek in alternate turns to complete a row, a column, or a diagonal with either three O's or three X's drawn in the spaces of a grid of nine squares; noughts and crosses.",
        screenshot : "Tic_Tac_Toe.png",
        link : "https://github.com/Kedar-Nadh/Tic-Tac-Toe"
    },
    {
        title : "Tenzies Game",
        text : "Roll until all dice are the same. Click each die to freeze it at its current value between rolls.",
        screenshot : "Tenzies_game.png",
        link : "https://github.com/Kedar-Nadh/Tenzies-Game/tree/main/Desktop/Tenzies%20Game"
    },
    {
        title : "Notes",
        text : "Notes is an awesome way to write your quick thoughts by typing manually and also you can add images, code snippets, links, etc.",
        screenshot : "Notes.png",
        link : "https://github.com/Kedar-Nadh/Notes"
    },
    {
        title : "Meme Generator",
        text : "You may add top and bottom text to the randomly generated meme template, download it as a jpeg file, and share it with your friends.",
        screenshot : "Meme_generator.png",
        link : "https://github.com/Kedar-Nadh/Meme-Generator"
    }
]

export {ProjectsData}